import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { analyticsService } from '../api/analytics.service';
import { ANALYTICS_KEYS } from './queryKeys';
import type { OverdueTasksParams } from '../types';

export function useOverdueTasks(params?: OverdueTasksParams) {
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useQuery({
    queryKey: ANALYTICS_KEYS.overdueTasks(activeOrganizationId ?? '', params),
    queryFn: ({ signal }) => analyticsService.getOverdueTasks(params, signal),
    staleTime: 60_000,
    enabled: !!activeOrganizationId,
  });
}
